module.exports = __webpack_public_path__ + "static/img/qpcr_7.90b3c66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qpcr_7.png
// module id = 0lft
// module chunks = 16